export default __webpack_public_path__ + "static/media/UploadIcon.6bd28c0e.svg";